import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';

export const BannerInfoAssistants = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        mt: 3,
        p: { xs: 3, md: 4 },
        backgroundColor: '#F8F7FA',
        borderRadius: 3,
        border: '1px solid #EAEAFF',
        mb: 3,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
        <Box sx={{ p: 1, borderRadius: '50%', backgroundColor: '#E8E7FD', display: 'flex', mr: 2 }}>
          <SmartToyIcon sx={{ color: '#696CFF', fontSize: 32 }} />
        </Box>
        <Box>
          <Typography
            variant="h6"
            sx={{ color: '#696CFF', fontWeight: 700, mb: 0.5, fontSize: '1.15rem' }}
          >
            ¿Qué es un Asistente?
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontWeight: 500, maxWidth: '80%' }}
          >
            Un asistente es una interfaz conversacional personalizada que interactúa con los
            usuarios. Puede configurarse con diferentes modelos de IA, instrucciones específicas
            (System Prompts) y capacidades adicionales como procesar archivos o mantener un
            historial.
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={3} sx={{ pl: { xs: 0, sm: 8.5 } }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <SettingsSuggestIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              Personalización y Ajuste
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Define el comportamiento del asistente mediante un prompt del sistema y ajusta
              parámetros creativos como la Temperatura y el Top P.
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <ArchitectureIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              Modelos Base
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Vincula tu asistente al Servicio IA que mejor se adapte a tus necesidades operativas
              (OpenAI, Gemini, Anthropic).
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <BuildCircleIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              Capacidades Avanzadas
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Habilita capacidades de razonamiento profundo, interacción con archivos, mantenimiento
              de historial y herramientas.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};
